module.exports = __webpack_public_path__ + "img/jiantou.532870f9.png";